// extracted by mini-css-extract-plugin
export default {"MarketingMessage":"instant-cards_MarketingMessage__anl20"};